import React, { useEffect, useState, lazy, Suspense } from "react";

const UserCalendar = lazy(() => import("../../../pages/event/UserCalendar"));
const OpeningTime = lazy(() => import("../../../pages/general/OpeningTime"));
const YouTube = lazy(() => import("./YouTube"));
const Location = lazy(() => import("../../../pages/contactus/Location"));
const SocialMedia = lazy(() => import("../../../pages/contactus/SocialMedia"));

const Landing = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <>


      <Suspense fallback={<div>Loading calendar...</div>}>
        <div style={{ marginTop: '20px' }}>
          <UserCalendar />
        </div>
      </Suspense>

      <Suspense fallback={<div>Loading opening time...</div>}>
        <OpeningTime />
      </Suspense>

      <br />

      <Suspense fallback={<div>Loading contacts...</div>}>
        <SocialMedia windowWidth={windowWidth} />
      </Suspense>
      <br />

      <Suspense fallback={<div>Loading location map...</div>}>
        <Location windowWidth={windowWidth} />
      </Suspense>


      <br /><br />

      <Suspense fallback={<div>Loading YouTube videos...</div>}>
        <YouTube windowWidth={windowWidth} />
      </Suspense>

    </>
  );
};

export default Landing;
